
//
window.SetupNewsFilters = function() {

	var filterCheckboxes = document.getElementsByClassName('news-filter-item-checkbox')

	if (filterCheckboxes.length > 0) {

		for (var i = 0; i < filterCheckboxes.length; i++) {

			var checkbox = filterCheckboxes[i];

			checkbox.addEventListener('change', function (e) {
				updateBasedOnCheckboxes();
			})
		}
	}

	function updateBasedOnCheckboxes() {

		var filterCheckboxes = document.getElementsByClassName('news-filter-item-checkbox')
		var filterString = "";

		for (var i = 0; i < filterCheckboxes.length; i++) {
			var checkbox = filterCheckboxes[i];

			if (checkbox.checked)
				filterString += checkbox.getAttribute('data-filter') + ',';
		}

		filterString = filterString.replace(/,\s*$/, "");

		var newURL = window.updateURLParameter(window.location.href, 'page', '1');
		newURL = window.updateURLParameter(newURL, 'tags', filterString);		

		window.location = newURL;
	}
}

if (document.readyState !== 'loading') {
	window.SetupNewsFilters();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetupNewsFilters();
	});
}